(function() {
    'use strict';

    var brand = window.__brand || {};

    var app = angular
        .module('anrescowebApp', [
            'ngStorage',
            'ngResource',
            'ngCookies',
            'ngAnimate',
            'ngAria',
            'ngCacheBuster',
            'ngFileUpload',
            'ui.bootstrap',
            'ui.bootstrap.datetimepicker',
            'ui.router',
            'infinite-scroll',
            // jhipster-needle-angularjs-add-module JHipster will add new module here
            'angular-loading-bar',
            'ui.select',
            'ngSanitize',
            'angular-bind-html-compile',
            'ui.tinymce',
            'ui.sortable',
            'ui.calendar',
            'oitozero.ngSweetAlert',
            'pascalprecht.translate'
        ])
        .constant('BRAND', brand)
        .run(run);

        app.config(["$translateProvider", function($translateProvider){

            var en_translations = {};

            var jp_translations = {
                'greeting': '332423423',
                'Account': 'アカウント',
                'Open Orders': '進行中のオーダー数',
                'View Orders': 'オーダーの確認',
                'Samples In-Progress': '到着待ち検体数',
                'Member Since': 'メンバー登録年',
                'Compliance Statistics': 'コンプライアンス統計',
                'No Statistics Available For This Time Range': '選択期間中のデータはありません',
                'Last 3 Months': '過去３ヶ月',
                'Last 6 Months': '過去６ヶ月',
                'Year To Date': '過去１年',
                'All': '全て',
                'Estimated Due Date Calendar': '納期予定日カレンダー',
                'Filter by': 'フィルター',
                'R&D': 'R&D',
                'Compliance': 'コンプライアンス',
                'Plant': '植物',
                'Concentrate': 'コンセントレート',
                'Edible': '飲食物',
                'Topical': '化粧品',
                'Environmental': 'Environmental',
                'Other': 'その他',
                'Go To Calendar': 'カレンダーを見る',
                'Your profile info': 'ご登録情報',
                'Business Name': '会社名',
                'Primary Contact Name': 'お名前',
                'Direct Phone': '電話番号',
                'Primary Contact Title': '役職名',
                'Website': 'ウェブサイト',
                'Email': 'メールアドレス',
                'Edit Profile': '登録情報変更',
                'Anresco contact info': 'Anresco担当者情報',
                'Primary Representative': '担当者名',
                'Primary Rep Email': '担当者メールアドレス',
                'Primary Rep Phone': '電話番号',
                'General Email': '一般メールアドレス',
                'General Phone': '一般電話番号',
                'Visit Our Site': 'Anrescoウェブサイトはこちら',
                'Home': 'ホーム',
                'Orders': 'オーダー履歴',
                'Samples': '検体履歴',
                'Public Gallery': 'パブリックギャラリー',
                'Calendar': 'カレンダー',
                'Manage': 'アカウント情報',
                'Search': '検索',
                'Number of entries': '合計オーダー数',
                'Filters': 'フィルター',
                'Apply Filters': '適用',
                'Close': '閉じる',
                'Order No.': 'オーダー番号',
                '# of Samples': '検体数',
                'Turnaround Time': '納期',
                'Receive Date Range': '到着日範囲',
                'Status': 'ステータス',
                'Created': 'オーダー済み',
                'Samples Received': '検体到着',
                'Preliminary Results': '中間結果',
                'Receive Date': '到着日',
                'Downloads': 'ダウンロード',
                '3 day (standard)': '3日（通常）',
                'Load': '読み込む',
                'Download Samples': '一括ダウンロード',
                'All Samples': '全ての検体',
                'In Progress': '進行中',
                'Completed': '完了',
                'Table View': 'テーブルビュー',
                'Gallery View': 'ギャラリービュー',
                'Sample No.': '検体番号',
                'Lot #': 'ロット番号',
                'Name': '検体名',
                'Completed Date': '完了日',
                'Starred': 'お気に入り',
                'Sample Name': '検体番号',
                'Enter Number': '番号を入力',
                'e.g.': '例）',
                'Category': 'カテゴリ',
                'Subcategory': 'サブカテゴリ',
                'Order Type': 'オーダー内容',
                '(range)': '範囲指定',
                'Pass/Fail Status': '合否判定',
                'Pass': '合格',
                'Fail': '不合格',
                'Undetermined': '未判定',
                'Completed Date Range': '完了日範囲指定',
                'Start Date': '開始日',
                'End Date': '終了日',
                'Date Range': '日付範囲',
                'Submit': '新規発注',
                'Retrieves by order complete date': 'オーダー作成日での検索',
                'Category (Sub)': 'サブカテゴリー',
                'Total Cannabinoids': 'カンナビノイド合計',
                'Order Number': 'オーダー番号',
                'Received Date': '到着日',
                'Estimated Due Date': '納期予定日',
                'Share': 'シェア',
                'Samples Tab': '検体履歴タブ',
                'TABLE VIEW': 'テーブルビュー',
                'unique features': 'の特徴',
                'View the results of more samples at one time': '一度に多くの検体情報や結果を閲覧可能',
                'Star samples for easy viewing later': '後で見返す時に便利なお気に入り登録機能',
                'Configure columns to quickly view the data that is important to you': '重要なデータを素早く表示するためのカラム設定',
                'GALLERY VIEW': 'ギャラリービュー',
                'View sample images': '検体の画像を表示',
                'For more granular information on a given sample, click on the hyperlinked Sample ID number': '特定の検体に関する詳細な情報については、リンク先の検体 ID番号をクリックしてください。',
                'Total': '合計',
                'Download': 'ダウンロード',
                'Tests': '詳細',
                'Sample ID': '検体ID',
                'Tested': '検査済み',
                'Plant': '植物',
                'Concentrate': 'コンセントレート',
                'Edible': '飲食物',
                'Topical': '化粧品',
                'Select': '選択',
                'Hash': 'ハッシュ',
                'Wax': 'ワックス',
                'Shatter': 'シャッター',
                'Kief': 'キーフ',
                'Rosin': 'ロジン',
                'Isolate': 'アイソレート',
                'Distillate': 'ディスティレート',
                'Crystalline': '結晶',
                'Cartridge': 'カートリッジ',
                'Terpene': 'テルペン',
                'Orally Consumed Concentrate': '経口摂取用濃縮物',
                'Crude': 'クルード',
                'Emulsion': '乳化加工物',
                'Baked Good': '焼き菓子',
                'Hard Candy/Lozenge': 'ハードキャンディ',
                'Soft Chew': 'ソフトキャンディ',
                'Chocolate': 'チョコレート',
                'Solid Fats (Butter, Sat. Fats)': '固形脂（バター、飽和脂肪）',
                'Capsule': 'カプセル',
                'Suppository': '座薬',
                'Syrup/Honey': 'シロップ/ハチミツ',
                'Beverage': '清涼飲料',
                'Carbonated Beverage': '炭酸飲料',
                'Tincture': 'ティンクチャー',
                'Liquid Fats (Oils)': '液状油（オイル）',
                'Orally Dissolving Product': '口腔内崩壊製品',
                'Gummy': 'グミ',
                'Powder': 'パウダー',
                'Infused Product': '含有製品',
                'Lotion/Balm': 'ローション/バーム',
                'Salve': '軟膏',
                'Transdermal Patch': '経皮パッチ',
                'Nanoemulsion': 'ナノエマルジョン',
                'Paper/Wrap': '紙/ラップ',
                'Cones/Tubes': 'コーン/チューブ',
                'Oil': 'オイル',
                'Inactive Ingredient': '添加物',
                'Select Action': 'アクションを選択',
                'Move Up': '上に移動',
                'Move Down': '下に移動',
                'Add Samples': '検体を追加',
                'Remove Selected': '選択アイテムを削除',
                'Set Criteria': '条件の設定',
                'Select Action': 'アクションを選択',
                'Reposition': '並び替え',
                'Select Type': '選択してください',
                'Order Type': 'オーダー内容',
                'Save': '保存',
                'Cancel': 'キャンセル',
                'Sample Number': '検体番号',
                'Lot Number': 'ロット番号',
                'Reset': 'リセット',
                'Search Samples': '検索',
                'RESULTS': '検索結果',
                'Type': '検体種類',
                'see list': '詳細表示',
                'No Samples': '該当なし',
                'CONTACT LIST': '連絡先',
                'COMPANY INFO': '会社情報',
                'Type of Business': '業種',
                'Business Description': '会社概要',
                'Street Address': '住所',
                'State': '都道府県',
                'Phone Number': '電話番号',
                'City': '市区町村',
                'Zip Code': '郵便番号',
                'Country': '国',
                'Fax': 'ファックス',
                'Contact Name': '連絡先氏名',
                'Phone': '電話番号',
                'Title': '役職',
                'Reporting': '結果報告',
                'Billing': '請求',
                'Edit Contact': '連絡先の変更',
                'First Name': 'ファーストネーム',
                'Direct Phone': '直通電話番号',
                'Last Name': 'ラストネーム',
                'To Receive': '受け取り',
                'Admin User': '管理者ユーザー',
                'Username': 'ユーザー名',
                'Password': 'パスワード',
                "leave blank if don't want to change": '変更しない場合は空白のまま',
                'New password': '新規パスワード',
                'Confirm the new password': '新規パスワードを再度入力してください',
                'Password strength': 'パスワードの安全性',
                'Recent Invoices': '直近の請求書',
                'Invoice No.': '請求書番号',
                'Invoiced Date': '発行日',
                'Amount': '金額',
                'recent orders submitted': '直近のオーダー状況',
                'Submit New': '新規オーダー',
                'Remove Sample?': '検体を削除しますか？',
                'Remove Samples?': '検体を削除しますか？',
                "Remove samples from Public Gallery? You can't undo this.": '一度削除すると復元することはできません。',
                "Remove sample from Public Gallery? You can't undo this.": '一度削除すると復元することはできません。',
                "Don't remove": 'キャンセル',
                'Yes, remove': '削除する',
                'Add New Contact': '新規連絡先追加',
                'This action cannot be undone.': '度削除すると復元することはできません。',
                'Delete':'削除',
                
                "Samples Page": "サンプル",
                "Order": "発注",
                "QA/R&D Testing": "検査発注",
                "Samples": "サンプル履歴",
                "Tests": "検査項目",
                "Review": "レビュー",
                "Download Excel": "ダウンロード（Excel）",
                "Upload Excel": "アップロード（Excel）",
                "Delete Samples": "サンプル削除",
                "Add New Samples": "サンプル追加",
                "Sample Name*": "サンプル名*",
                "Lot/Batch #": "ロット/バッチ番号",
                "Product Category": "製品カテゴリ",
                "Product Type": "製品種別",
                "Inhalable/Non-Inhalable": "吸入用 / 非吸入用",
                "Product Specifications": "製品詳細",
                "Please input any internal specifications, label claims, or pass/fail criteria into this field (e.g. 18-22% THC, 100mg CBD +/- 10%, <400ppm acetonitrile). This will allow our lab to proactively investigate any out of spec result, saving time and reducing the potential for analytical or reporting error.": "厚生労働省が定める製品区分、社内規格値、ラベル表示数値、または合否判定基準をこの欄にご記入ください（例：THC含有量、CBD含有量、溶媒残留基準など）。\n規格外の結果が出た場合に迅速に原因を調査できるため、時間の節約につながり、分析や報告ミスの可能性を低減できます。",
                "Sample Name": "サンプル名",
                "e.g. abc123": "例：abc123",
                "Select Category": "カテゴリを選択",
                "Select Type": "種別を選択",
                "Select Inhalable": "吸入種別を選択",
                "e.g. 20% Vit C": "例：CBD 10mg (Other)",
                "Strain Name": "ストレイン名称",
                "Optional": "任意",
                "Strain Type": "ストレイン種別",
                "Sativa": "サティバ",
                "Indica": "インディカ",
                "Hybrid": "ハイブリッド",
                "CBD": "CBD",
                "Label Claims": "表示含有量",
                "Source UID <br>Optional": "ソースUID<br>任意",
                "Source UID": "ソースUID",
                "Medicinal Batch": "医療用バッチ",
                "Next": "次へ",
                "Test Page": "",
                "Search for tests...": "検査項目を検索",
                "Clear": "クリア",
                "Panels": "パネル",
                // "Select Panel": "HIDE",
                // "Clear Panel": "HIDE",
                // "Hide Anresco Panel": "HIDE",
                "Cannabinoid Profile - LCMSMS (Japan Limits - Essential)": "THC残留限度値対応カンナビノイド含有量（10種）",
                "Cannabinoid profiling via LCMSMS per the requirements of Japan MHLW.": "日本厚生労働省の基準に対応した、LC-MS/MSを用いた高感度のカンナビノイド検査（D8-THC, THCV, THCVAを除く10種）を実施します。",
                "Cannabinoid Profile - LCMSMS (Japan Limits)": "THC残留限度値対応カンナビノイド含有量（通常13種）",
                "Cannabinoid screen performed via LC-MS/MS for extremely low level detection per the requirements of Japan MHLW.": "日本厚生労働省の基準に対応した、LC-MS/MSを用いた高感度のカンナビノイド検査（13種）を実施します。",
                "Cannabinoid Profile Extended Analytes LCMSMS (Japan Limits)": "THC残留限度値対応カンナビノイド含有量（追加分析パッケージ）",
                "Extended cannabinoid screen performed via LC-MS/MS for extremely low level detection per the requirements of Japan MHLW.": "日本厚生労働省の基準に対応した、LC-MS/MSを用いた高感度のカンナビノイド検査（追加分析パッケージ）を実施します。",
                "Pesticide & Mycotoxin Screen - CA DCC": "残留農薬＆マイコトキシン：コンプライアンス",
                "Panel includes 21 category I pesticides, 45 category II pesticides, aflatoxins, and ochratoxins as required by the California DCC.": "カリフォルニア州大麻取締局の要件に準拠した21種類のカテゴリーI農薬、45種類のカテゴリーII農薬、アフラトキシン、およびオクラトキシンが含まれます。",
                "Pesticide Screen - CA DCC": "残留農薬コンプライアンス",
                "Screening for 66 pesticides via LC-MS/MS and GC-MS/MS, applying limits as outlined by the California Department of Cannabis Control (DCC).": "LC-MS/MSおよびGC-MS/MSを使用し、カリフォルニア州大麻取締局の基準に基づいた66種類の農薬スクリーニングを実施します。",
                "Microbiological QA Screen": "微生物試験：品質管理",
                "Panel analysis for the following quantitative assays: standard plate count, yeast & mold, coliforms, and generic e. coli.": "標準平板菌数、酵母およびカビ、大腸菌群、一般大腸菌の定量試験を含む微生物分析パネル。",
                "Microbiological Screen (Inhalables) - CA DCC": "微生物試験：コンプライアンス（吸入製品）",
                "Panel analysis for STEC, salmonella, and aspergillus, per DCC guidelines for inhalable products.": "吸入製品を対象に、カリフォルニア州大麻取締局ガイドラインに準拠した志賀毒素産生性大腸菌、サルモネラ菌およびアスペルギルスのパネル分析。",
                "Microbiological Screen (Non-inhalables) - CA DCC": "微生物試験：コンプライアンス（非吸入製品）",
                "Panel analysis for STEC and salmonella, per DCC guidelines for non-inhalable products.": "非吸入製品を対象に、カリフォルニア州大麻取締局ガイドラインに準拠した志賀毒素産生性大腸菌およびサルモネラ菌のパネル分析。",
                "Heavy Metals - CA DCC": "重金属",
                "Screening for arsenic, cadmium, lead, and mercury via ICP-MS, applying limits as outlined by the California Department of Cannabis Control (DCC).": "ICP-MSを用いたヒ素、カドミウム、鉛、水銀のスクリーニング試験（重金属検査）を実施します。",
                "Residual Solvent Screen - CA DCC": "残留溶媒",
                "Screening for 20 residual solvents via GC-MS, applying limits as outlined by the California Department of Cannabis Control (DCC).": "GC-MSを使用し、20種類の残留溶媒のスクリーニングを実施します。",
                "Mycotoxins": "マイコトキシン",
                "Includes Aflatoxins B1, B2, G1, G2, and Ochratoxin A.": "アフラトキシン B1、B2、G1、G2、およびオクラトキシンAの検査を含みます。",
                "Foreign Material - CA DCC": "異物混入物",
                "Homogeneity (5 Samples)": "均質性試験（５サンプル）",
                "Homogeneity USP (10 samples)": "均質性試験",
                "Comparative analysis of cannabinoid results from 10 samples from within the same batch, per USP guidelines.": "米国薬局法（USP）のガイドラインに準拠したカンナビノイドの含有量の比較分析を実施（同一ロット内の複数検体における成分濃度の均質性評価）します。",
                "Terpene Profile": "テルペン分析",
                "Profiling of 27 of the most commonly found terpenoids in cannabis flower and products via GC-MS.": "GC-MSを使用し、大麻の花や製品に最も一般的に含まれる27種類のテルペノイドのプロファイリングを実施します。",
                "Flavonoid Profile": "フラボノイド分析",
                "Apigenin| Baicalin| Cannflavin A| Cannflavin B| Catechin| Chrysin| Epicatechin| Epigallocatechin Gallate| Isovitexin| Kaempferol| Luteolin| Myricetin| Orientin| Quercetin| Rutin| Vitexin": "アピゲニン｜ケルセチン｜ルテオリン｜ミリセチン｜ケンフェロール｜ルチン｜ビテキシン｜イソビテキシン｜ビテキシン｜オリエンチン｜イソビテキシン｜ルチン｜イソビテキシン｜カテキン｜エピカテキンガレート（EGCG）｜ビテキシン",
                "STEC (Shiga Toxin Producing E. Coli)": "志賀毒素産生性大腸菌",
                "Salmonella": "サルモネラ",
                "Standard Plate Count": "標準平板菌数",
                "Vitamin E Acetate (Tocopheryl Acetate)": "ビタミンEアセテート（トコフェリルアセテート）",
                "Water Activity": "水分活性",
                "Yeast & Mold": "イースト菌及びカビ菌",
                "Previous": "戻る",
                "Order Page": "",
                "Contact Name": "ご登録名",
                "Email Recipients": "メール通知先",
                "Contact Phone #": "お電話番号",
                "Project/PO#<br>Optional": "プロジェクト番号<br>任意",
                "Project/PO#": "プロジェクト番号",
                "Invoicing Address": "ご請求先",
                "Customer/Reporting Address<br>Choose Location/Add New": "発行先名<br>住所選択または新規追加",
                "Customer/Reporting Address": "発行先名",
                "Choose Location/Add New": "住所選択または新規追加",
                "Manufacturing Address<br>Choose Location/Add New": "製造者名<br>住所選択または新規追加",
                "Pickup/Arrival Date": "検体到着予定日",
                "Tracking Number": "追跡番号",
                "Delivery Preference<br>Anresco Pick-Up<br>Client Drop-Off<br>Mail": "提出方法<br>Anrescoによる集荷<br>お客様ご自身でのお届け<br>輸送",
                "Delivery Preference": "提出方法",
                "Turnaround Time<br>5 days (standard)<br>4 days (rush)<br>3 days (rush)<br>2 days (rush)<br>1 days (rush)": "納期<br>5営業日（通常）<br>4営業日（ラッシュ）<br>3営業日（ラッシュ）<br>2営業日（ラッシュ）<br>1営業日（ラッシュ）",
                "Turnaround Time": "納期",
                "5 days (standard)": "5営業日（通常）",
                "4 days (rush)": "4営業日（ラッシュ）",
                "3 days (rush)": "3営業日（ラッシュ）",
                "2 days (rush)": "2営業日（ラッシュ）",
                "1 day (rush)": "1営業日（ラッシュ）",
                "Standard turnaround time varies depending on analysis.\n\t•\tRoutine cannabis and hemp testing has a standard 3 day TAT.\n\t•\tRoutine microbiological and kratom testing has a standard 5 day TAT.\n\t•\tNutritional labeling has a standard 15 day TAT.\n\t•\tMost other assays have a standard 10 day TAT.\n\nExpedited TATs are available with pre-approval and a corresponding surcharge. Please contact your rep or support@anresco.com for additional info regarding these options.": "標準の納期は、分析内容によって異なります。\n        •        厚生労働省THC残留限度値に対応したカンナビノイド含有量試験の標準納期は5営業日です。\n        •        一般的な大麻製品試験の標準納期は3営業日です。\n        •        一般的な微生物試験の標準納期は5営業日です。\n        •        その他の多くの分析の標準TATは10営業日です。\n\nラッシュサービスには事前承認と追加料金が必要です。詳細については、担当者または japan@anresco.com までお問い合わせください。",
                "Standard turnaround time varies depending on analysis.":"標準の納期は、分析内容によって異なります。 ",
                "Routine cannabis and hemp testing has a standard 3 day TAT.":"  厚生労働省THC残留限度値に対応したカンナビノイド含有量試験の標準納期は5営業日です。",
                "Routine microbiological and kratom testing has a standard 5 day TAT.":"般的な大麻製品試験の標準納期は3営業日です。",
                "Nutritional labeling has a standard 15 day TAT..":"般的な微生物試験の標準納期は5営業日です。",
                "Most other assays have a standard 10 day TAT.":"その他の多くの分析の標準TATは10営業日です。",
                "Expedited TATs are available with pre-approval and a corresponding surcharge. Please contact your rep or support@anresco.com for additional info regarding these options.":"ラッシュサービスには事前承認と追加料金が必要です。詳細については、担当者または japan@anresco.com までお問い合わせください。",

                "Special Instructions": "その他特記事項",
                "Estimated Report Date": "納期予想日",
                "Review Page": "",
                "Prepayment is required for all new clients. Payment terms can be negotiated for routine clients. After the invoice due date, a finance charge of 2% per month will be applied and any discounts will be nullified.": "初めてご利用されるお客様は前払いが必要です。定期的にご利用いただくお客様については、支払い条件の交渉が可能です。請求書の支払期日を過ぎた場合、月額2%の延滞金が適用され、すべての割引は無効となります。",
                "Federal Tax ID # 94-2528801": "連邦税務識別番号 (Federal Tax ID): 94-2528801",
                "DUNS # 05-458-2416": "DUNS番号: 05-458-2416",
                "Cancel Order": "注文をキャンセル",
                "After Submittion Page": "",
                "Your order has been submitted successfully": "ご発注ありがとうございます。正常に受け付けました。",
                "Print Submission Form": "発注フォームを印刷",
                "View Packaging & Shipping Guidelines": "サンプル発送ガイドラインを確認",
                "Anresco Receiving Address<br>Attn: Lab Sample<br>Anresco Laboratories<br>1375 Van Dyke Avenue<br>San Francisco, CA 94124": "国内発送先：\nAnresco Japan\n〒176-0023　\n東京都練馬区中村北1-13-13 OHDビル702\n03-6427-1829\n\n米国発送先：\nAttn: Lab Sample\nAnresco Laboratories\n1375 Van Dyke Avenue\nSan Francisco, CA 94124",
                "Anresco Receiving Address": "国内発送先：\u003cbr\u003eAnresco Japan \u003cbr\u003e 〒176-0023　\u003cbr\u003e東京都練馬区中村北1-13-13 OHDビル702\u003cbr\u003e03-6427-1829\u003cbr\u003e\u003cbr\u003e米国発送先：",                "Check Order Status": "オーダー状況の確認",
                "Submit Another Order": "新規オーダー発注",

                "Beverage": "飲料",
                "Hard Candy／Lozenge": "飴・トローチ",
                "Liquid Fats (Oil)": "液状油脂（オイル）",
                "Orally Dissolving Products": "口腔内崩壊錠",
                "Powder": "粉末",
                "Soft Chew": "チュアブル",
                "Solid Fats (Butter, sat. fats)": "固形油脂（バターなど）",
                "Suppository": "坐薬",
                "Syrup/Honey": "シロップ・ハチミツ",
                "Concentrate": "濃縮物",
                "Cartridge": "ベイプリキッド、カートリッジ",
                "Emulision": "乳濁液",
                "Orally Consumed Concentrate": "経口摂取濃縮物",
                "inactive Ingredients": "不活性成分",
                "Nanoemulision": "ナノ乳濁液",
                "Oil": "油脂",
                "Flower": "花穂",
                "Lotion/Balm": "ローション・バーム",
                "Transdermal Patch": "経皮摂取パッチ",
                "Leaf/Trim": "葉っぱ",
                "Hemp": "ヘンプ",
                "Infused Pre-Roll": "添加ジョイント",
                "Seed": "種子",
                "No sample has been added": "追加された検体がありません",
                "Time of Collection": "回収時期",
                "Sample Matrix": "検体マトリックス",
                "Sample Description": "検体詳細",
                "Email Recipients": "Eメール受信者",
                "Reporting Address": "発行先住所",
                "Delivery": "配達",
                "Frequent Tests": "頻繁な検査項目",
                "Configured Tests": "設定された検査項目",
                "Requested Tests": "要求された検査項目",
                "Category (Type)": "カテゴリ（種別）",
                "Compliance Testing": "コンプライアンス検査",
                "Matrix": "マトリックス",
                "Batch Name": "バッチ名",
                "No batch has been added": "追加されたバッチがありません",
                "Add New Batch": "新規バッチを追加",
                "TAG UID": "タグUID",
                "Product Batch": "製造バッチ",
                "Harvest Batch": "収穫バッチ",
                "Add Terpenoid Profile": "テルペノイド検査を追加",
                "Analyze by LCMSMS": "LCMSMSによる分析",
                "Product Batch Size (Units)*": "製造バッチサイズ（単位）*",
                "Manufacture Date": "製造日",
                "Unit Weight (g)*": "単位重量（g）*",
                "Submit Order": "この内容で発注",
                
                "Cannabinoid Profile - LCMSMS (Japan Limits)": "THC残留限度値対応カンナビノイド含有量（通常13種）",
                "Cannabinoid Profile - LCMSMS Essential Analytes (Japan Limits)": "THC残留限度値対応カンナビノイド含有量（10種）",
                "Cannabinoid Profile Extended Analytes LCMSMS (Japan Limits)": "THC残留限度値対応カンナビノイド含有量（30種）",
                "Residual Solvent Screen - CA DCC": "残留溶媒 - カリフォルニア州法準拠",
                "Heavy Metals - CA DCC": "重金属 - カリフォルニア州法準拠",
                "Flavonoid Profile": "フラボノイド分析",
                "Heavy Metal Screen - Universal Hemp": "重金属 - 全米基準対応",
                "Homogeneity (5 Samples)": "均質性試験（5サンプル）",
                "Homogeneity USP (10 samples)": "均質性試験（アメリカ薬局方準拠）",
                "Microbiological QA Screen": "微生物試験：品質管理",
                "Microbiological Screen (Inhalables) - CA DCC": "微生物試験 - カリフォルニア州法準拠（吸入製品）",
                "Microbiological Screen (Non-inhalables) - CA DCC": "微生物試験 - カリフォルニア州法準拠（非吸入製品）",
                "Microbiological Screen - Universal Hemp": "微生物試験 - 全米基準対応",
                "Mycotoxins": "マイコトキシン",
                "Pesticide & Mycotoxin Screen - CA DCC": "残留農薬＆マイコトキシン - カリフォルニア州法準拠",
                "Pesticide Screen - CA DCC": "残留農薬 - カリフォルニア州法準拠",
                "Pesticide Screen - Universal Hemp": "残留農薬 - 全米基準対応",
                "STEC (Shiga Toxin Producing E. Coli)": "志賀毒素産生性大腸菌",
                "Salmonella": "サルモネラ菌",
                "Standard Plate Count": "標準平板菌数",
                "Terpene Profile": "テルペン分析",
                "Vitamin E Acetate (Tocopheryl Acetate)": "ビタミンEアセテート（トコフェリルアセテート）",
                "Water Activity": "水分活性",
                "Yeast and Mold - Universal Hemp - TESTING": "酵母菌＆カビ",
                "Foreign Material - CA DCC": "異物混入",
                'Full Panel "Standard" - Concentrate': "フルパネル検査 - スタンダード（濃縮物）",
                'Full Panel "Standard" - Non inhalable/solid': 'フルパネル検査 - スタンダード（固形物・非吸引）',
                'Full Panel "Standard" - Non inhalable/liquid': 'フルパネル検査 - スタンダード（液体・非吸引）',
                'Full Panel "Full Scope" - Concentrate': 'フルパネル検査 - フルスコープ（濃縮物）',
                'Full Panel "Full Scope" - Non inhalable/solid': 'フルパネル検査 - フルスコープ（固形物・非吸引）',
                'Full Panel "Full Scope" - Non inhalable/liquid': 'フルパネル検査 - フルスコープ（液体・非吸引）'
            }

            $translateProvider.translations('en',en_translations);

            $translateProvider.translations('jp',jp_translations);

            $translateProvider.preferredLanguage('en');

          }]);

    app.filter('highlightMatch', function() {
        return function(words, search) {
            return (search ? words.replace(new RegExp('(' + search + ')', 'i'), '<span class="filter-match">$1</span>') : words);
        }
    });

    app.filter('lngFilterOptions', function() {
        return function (options, lng) {
            if (lng == 'jp') {
                var filteredOptions = [];
                var ignore = ['Plant', 'Environmental']
                if (options && options.length) {
                    options.forEach( function(op) {
                        if (!ignore.includes(op.text || op.name)) filteredOptions.push(op);
                    });
                }
                return filteredOptions
            } else return options;

        }
    });

    app.filter('isEmpty', [function() {

        return function(objectOrArray) {

            if(Array.isArray(objectOrArray)) {

                return !objectOrArray.length > 0;

            }

            return angular.equals({}, objectOrArray);

        };

    }]);

    app.filter('numberFormat', function() {
        return function(format, input) {
          var lastChar;

          format= '(___) ___-____';

          if (!input) {
            return;
          }

          for (var index = 0; index < input.length; index++) {
            var char = input.charAt(index);
            if ([0, 1, 2, 3, 4, 5, 6, 7, 8, 9].includes(parseInt(char))) {
              if (format.indexOf('_') >= 0) {
                format = format.replace('_', char);
                lastChar = char;
              }
            }
          }

          if (lastChar) {
            return format.substring(0, format.lastIndexOf(lastChar) + 1);
          }
        }
      });

      app.directive('phoneNumberFormat', ['$filter', function($filter) {
        return {
          resolve: 'A',
          replace: true,
          link: function(scope, ele, attrs) {
            var modelName = attrs.ngModel;
            var lastNestedObj = attrs.lastnestedobject
            var formatValue = attrs.format;

            scope.$watch(modelName, function(newValue, oldValue) {
              Object.byString(scope, modelName)[lastNestedObj] = $filter('numberFormat')(formatValue, newValue);
            });
          }
        }
      }]);

    app.filter('utcToLocal', ['$filter', function($filter) {
    	return function(utcDateString, format) {
    		if (!utcDateString) return;

    		if (utcDateString.indexOf('Z') === -1 && utcDateString.indexOf('+') === -1) utcDateString += 'Z';

    		return $filter('date')(utcDateString, format);
    	}
    }]);

    app.directive('collapse', ['$animate', '$q', '$parse', '$injector', function ($animate, $q, $parse, $injector) {
        var $animateCss = $injector.has('$animateCss') ? $injector.get('$animateCss') : null;
        return {
            link: function(scope, element, attrs) {
                var expandingExpr = $parse(attrs.expanding),
                    expandedExpr = $parse(attrs.expanded),
                    collapsingExpr = $parse(attrs.collapsing),
                    collapsedExpr = $parse(attrs.collapsed),
                    horizontal = false,
                    css = {},
                    cssTo = {};

                init();

                function init() {
                    horizontal = !!('horizontal' in attrs);
                    if (horizontal) {
                        css = {
                            width: ''
                        };
                        cssTo = {width: '0'};
                    } else {
                        css = {
                            height: ''
                        };
                        cssTo = {height: '0'};
                    }
                    if (!scope.$eval(attrs.collapse)) {
                        element.addClass('in')
                            .addClass('collapse')
                            .attr('aria-expanded', true)
                            .attr('aria-hidden', false)
                            .css(css);
                    }
                }

                function getScrollFromElement(element) {
                    if (horizontal) {
                        return {width: element.scrollWidth + 'px'};
                    }
                    return {height: element.scrollHeight + 'px'};
                }

                function expand() {
                    if (element.hasClass('collapse') && element.hasClass('in')) {
                        return;
                    }

                    $q.resolve(expandingExpr(scope))
                        .then(function() {
                            element.removeClass('collapse')
                                .addClass('collapsing')
                                .attr('aria-expanded', true)
                                .attr('aria-hidden', false);

                            if ($animateCss) {
                                $animateCss(element, {
                                    addClass: 'in',
                                    easing: 'ease',
                                    css: {
                                        overflow: 'hidden'
                                    },
                                    to: getScrollFromElement(element[0])
                                }).start()['finally'](expandDone);
                            } else {
                                $animate.addClass(element, 'in', {
                                    css: {
                                        overflow: 'hidden'
                                    },
                                    to: getScrollFromElement(element[0])
                                }).then(expandDone);
                            }
                        }, angular.noop);
                }

                function expandDone() {
                    element.removeClass('collapsing')
                        .addClass('collapse')
                        .css(css);
                    expandedExpr(scope);
                }

                function collapse() {
                    if (!element.hasClass('collapse') && !element.hasClass('in')) {
                        return collapseDone();
                    }

                    $q.resolve(collapsingExpr(scope))
                        .then(function() {
                            element
                            // IMPORTANT: The width must be set before adding "collapsing" class.
                            // Otherwise, the browser attempts to animate from width 0 (in
                            // collapsing class) to the given width here.
                                .css(getScrollFromElement(element[0]))
                                // initially all panel collapse have the collapse class, this removal
                                // prevents the animation from jumping to collapsed state
                                .removeClass('collapse')
                                .addClass('collapsing')
                                .attr('aria-expanded', false)
                                .attr('aria-hidden', true);

                            if ($animateCss) {
                                $animateCss(element, {
                                    removeClass: 'in',
                                    to: cssTo
                                }).start()['finally'](collapseDone);
                            } else {
                                $animate.removeClass(element, 'in', {
                                    to: cssTo
                                }).then(collapseDone);
                            }
                        }, angular.noop);
                }

                function collapseDone() {
                    element.css(cssTo); // Required so that collapse works when animation is disabled
                    element.removeClass('collapsing')
                        .addClass('collapse');
                    collapsedExpr(scope);
                }

                scope.$watch(attrs.collapse, function(shouldCollapse) {
                    if (shouldCollapse) {
                        collapse();
                    } else {
                        expand();
                    }
                });
            }
        };
    }]).directive('dropdownCheckboxes', dropdownCheckboxes);

    function dropdownCheckboxes() {
    	return {
        	link: function(scope, element, attrs) {
        		var $btn = $(element).find('button');
        		var $div = $(element).find('div');

        		$btn.click(function(){
        			$(this).toggleClass('btn-active');
        			$div.toggle();
        		});

        	}
    	}
    }

    run.$inject = ['stateHandler', '$rootScope', 'BRAND', 'uibDatepickerPopupConfig'];

    Object.byString = function(o, s) {
        s = s.replace(/\[(\w+)\]/g, '.$1');
        s = s.replace(/^\./, '');
        var a = s.split('.');
        for (var i = 0, n = a.length-1; i < n; ++i) {
            var k = a[i];
            if (k in o) {
                o = o[k];
            } else {
                return;
            }
        }
        return o;
    }

    function run(stateHandler, $rootScope, BRAND, uibDatepickerPopupConfig) {
        $rootScope.brand = BRAND || {};
        if (BRAND && BRAND.branding && BRAND.branding.portal_name) {
            document.title = BRAND.branding.portal_name;
        }
        // Date inputs across the app interpolate {{dateformat}} for uib-datepicker-popup.
        // It was never defined, so the popup fell back to parsing typed text as yyyy-MM-dd
        // and silently discarded MM/DD/YYYY entries while the text stayed visible (AP-295).
        // The alternate formats apply to every popup so typed dates parse leniently.
        $rootScope.dateformat = 'MM/dd/yyyy';
        uibDatepickerPopupConfig.altInputFormats = ['M!/d!/yyyy', 'yyyy-MM-dd'];
        stateHandler.initialize();
    }
})();
